// src/components/SubmissionRecap.tsx
import React from 'react';
import { Submission } from '../utils/storage';

interface SubmissionRecapProps {
  submission: Submission | null;
  onCreateNew: () => void;
}

export function SubmissionRecap({ submission, onCreateNew }: SubmissionRecapProps) {
  if (!submission) {
    return <div>No submission data available.</div>;
  }
  
  const filledRankings = submission.ranking.filter(item => item !== null) as any[];
  const username = submission.username || 'Your';
  const maxRank = submission.event.maxRankings || filledRankings.length;
  
  return (
    <div className="py-2 md:py-6">
      {/* Thank you heading and subtitle */}
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Thank you for participating!</h1>
        <p className="text-gray-600 mt-2">We will contact you if you win the competition!</p>
      </div>
      
      <div className="bg-white rounded-lg border overflow-hidden">
        {/* Title card */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-gray-700">
            {username}'s Top {maxRank} Eurovision 2025 Ranking
          </h2>
        </div>
        
        {/* Ranking list */}
        <div className="divide-y divide-gray-200">
          {filledRankings.map((participant, index) => (
            <div key={participant.id} className="flex items-center p-3">
              {/* Ranking number */}
              <div className="flex-shrink-0 font-bold text-gray-500 w-6 text-center mr-2">
                {index + 1}
              </div>
              
              {/* Participant image and flag */}
              <div className="relative flex-shrink-0 mr-4">
                <img 
                  src={`${process.env.PUBLIC_URL}/${participant.image}`} 
                  alt={participant.name}
                  className="w-16 h-16 object-cover rounded-md"
                />
                <div className="absolute -bottom-1 -right-1">
                <img 
                  src={`${process.env.PUBLIC_URL}/flags/${participant.countryCode}.png`} 
                  alt={`${participant.country} flag`}
                  className="w-6 h-6"
                />
                </div>
              </div>
              
              {/* Participant details */}
              <div className="flex-grow">
                <div className="font-bold">{participant.country}</div>
                <div className="text-sm text-gray-700">{participant.name}</div>
                <div className="text-xs text-gray-500">{participant.songTitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Share button */}
      <div className="mt-4">
        <button
          onClick={() => {
            // In a real app, this would trigger share functionality
            alert('Sharing functionality would be implemented here!');
            // For now, allow creating a new ranking
            onCreateNew();
          }}
          className="w-full bg-pink-500 hover:bg-pink-600 text-white font-medium py-3 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        >
          Share your top {maxRank}!
        </button>
      </div>
    </div>
  );
}